import Vue from 'vue'
import App from './App'
import { registerComponents } from "@/global-config/component/component-registration/register-components"
import router from "@/global-config/router/route"
import globalMixin from "@/mixin/mixin"
import store from "@/global-config/store/index.js"
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import VeeValidate from 'vee-validate';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueFeather from 'vue-feather';
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css"

const veeValidateConfig = {
    aria: true,
    classNames: {},
    classes: false,
    delay: 0,
    dictionary: null,
    errorBagName: 'errorBag', // change if property conflicts
    events: 'input',
    fieldsBagName: 'fields',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: true,
    locale: 'en',
    validity: false,
    useConstraintAttrs: true
};

const options = {
    maxToasts: 1,
    newestOnTop: true,
    filterBeforeCreate: (toast, toasts) => {

        if(sessionStorage.getItem('stack') == 'full' && toast.type == 'error'){
            return false
        }

        if (toasts.filter(
            t => t.type === toast.type && toast.type == 'error'
        ).length !== 0) {
            // Returning false discards the toast
            sessionStorage.setItem('stack','full');
            return false;
        }
        // You can modify the toast if you want
        return toast;
    }
};

Vue.use(VueFeather);
Vue.use(BootstrapVue); // Use bootstrap-vue
Vue.component("v-select", vSelect); //vue-select for dropdown
Vue.component('PulseLoader', PulseLoader); // loader component for common table
Vue.component('ClipLoader', ClipLoader); // clip loader for submit button
Vue.component('multiselect', Multiselect) // Vue multiselect option
Vue.use(VeeValidate, veeValidateConfig);
Vue.use(Toast,options);
Vue.config.productionTip = false
Vue.mixin(globalMixin);
registerComponents(Vue);


require('./global-config/router/routes-interceptor/routes-interceptor')

new Vue({
    router,
    store,
    components: { App },
    template: '<App/>',
}).$mount('#app')

